import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import UpdateGrid from './components/UpdateGrid';
import ReviewSection from './components/ReviewSection';
import CTASection from './components/CTASection';
import { faqs } from '@/mocks/about';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '叮当漫画网',
    url: 'http://kjbooks.cn/',
    description: '叮当漫画网推出全球诡异时代漫画无删减版，下拉式免费阅读，所有内容完整呈现，无需付费。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://kjbooks.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '叮当漫画网',
    url: 'http://kjbooks.cn/',
    description: '国内领先的免费漫画阅读平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@kjbooks.cn',
      contactType: 'customer service',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '叮当漫画网 - 首页',
    url: 'http://kjbooks.cn/',
    description: '全球诡异时代漫画无删减版，下拉式免费阅读，涵盖悬疑、恐怖、奇幻、冒险等热门分类。',
    isPartOf: { '@id': 'http://kjbooks.cn/#website' },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.answer,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeatureGrid />
          <UpdateGrid />
          <ReviewSection />

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-3xl mx-auto">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-100 mb-8 text-center">常见问题</h3>
              <div className="space-y-4">
                {faqs.map((faq, index) => (
                  <details key={index} className="group bg-background-50 rounded-xl overflow-hidden">
                    <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                      <span className="text-foreground-200 text-sm font-medium pr-4">{faq.question}</span>
                      <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-foreground-500 text-sm leading-relaxed">{faq.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}